<template>
  <div class="ViewApiClient">
    <HeaderPage>
      <el-button
          v-if="!apiDetails.id"
          style="height: 44px; margin-left: 1rem"
          @click="openGenrateToken"
      >
        Gerar Novo Token
      </el-button>
      <el-button
          v-else
          style="height: 44px; margin-left: 1rem"
          @click.prevent="dialogVisibleGene = true"
      >
        Gerar Novo Token
      </el-button>

    </HeaderPage>
    <el-card v-loading="loadingPage" :class="{'card-center': !apiDetails.id}">
      <el-row v-if="apiDetails.id" v-loading="loadingPage" :gutter="100">
        <el-col :sm="24" :md="24">
          <p style="font-size: 1rem; display: inline-block; color: #606266;">
            <b>Email: </b>
            {{ apiDetails.email }}
          </p>
        </el-col>
        <el-col :sm="24" :md="24">
          <p style="font-size: 1rem; display: inline-block; color: #606266;">
            <b>Tipo de Acesso: </b>
            {{ apiDetails.type === 'develop' ? 'Desenvolvimento' : 'Produção' }}
          </p>
        </el-col>
        <el-col :sm="24" :md="24">
          <div style="width: 50%;">
            <div style="height: 280px; background: #dadada; padding: 15px;overflow-wrap: break-word; word-wrap: break-word; word-break: break-word;">
              {{ dialogVisible ? tokenJwt : '' }}
            </div>
          </div>
        </el-col>
        <el-col :sm="24" :md="24" style="margin-top: 1.5rem; display: flex; justify-content: flex-end;">
          <div>
            <el-button @click.prevent="dialogVisible = !dialogVisible">
              <span v-if="dialogVisible">Esconder Token</span>
              <span v-else>Visualizar Token</span>
            </el-button>
            <el-button type="danger" @click.prevent="deleteApiClient">Excluir</el-button>
          </div>
        </el-col>
      </el-row>
      <p v-else style="font-family: 'Avenir', Helvetica, Arial, sans-serif">
        Ainda não possui token
      </p>
    </el-card>

    <el-dialog
        :title="ruleForm.id ? `Gerar Novo Token` : `Gerar Token`"
        :visible.sync="dialogVisibleGene"
        width="30%"
    >
      <div>
        <el-form v-loading="loadingPage" v-if="dialogVisibleGene" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
          <p v-if="apiDetails.id" style="color: #f85e59; text-align: center;">
            *Se você gerar um novo token, o atual será invalidado.
          </p>
          <p v-else style="color: #357c39; text-align: left;">
            *Iniciar a integração em desenvolvimento
          </p>
          <el-form-item prop="password" label="Senha" :error="error.password">
            <el-input  size="large"
                       placeholder="● ● ● ● ● ●"
                       v-model="ruleForm.password"
                       :type="type" required>
              <i class="el-icon-view el-input__icon" slot="suffix" @click="changeType">
              </i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="apiDetails.id" @click.prevent="generateToken">Gerar Novo token</el-button>
        <el-button type="primary" v-else @click.prevent="handleCreateToken">Gerar token</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteApiClient,
  postApiClient,
  postGenerateTokenApiClient,
  putApiClient,
} from "@/app/domains/Config/services";
import HeaderPage from "@/app/components/HeaderPage";
import {getApiClient} from "@/app/domains/Config/services";
import {clearRuleForm, makeErrorFilds} from "@/app/plugins/utils";
import {mapGetters} from "vuex";

export default {
  name: "ViewApiClient",
  components: {
    HeaderPage,
  },
  data () {
    return {
      dialogVisible: false,
      dialogVisibleGene: false,
      loadingPage: true,
      apiDetails: {},
      ruleForm: {},
      error: {},
      rules: {},
      tokenJwt: '',
      type: 'password',
    }
  },
  watch: {
    dialogVisibleGene(to) {
      if (to && this.apiDetails.id) {
        this.ruleForm.email = this.apiDetails.email;
        this.ruleForm.user_id = this.apiDetails.user_id;
        this.ruleForm.type = "production";
      } else {
        this.close();
      }
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    isEdit: function () {
      return !!(this.ruleForm.id)
    }
  },
  methods: {
    changeType (ev) {
      if (this.type === 'password') {
        this.type = 'text'
      } else if (this.type === 'text') {
        this.type = 'password'
      }
    },
    deleteApiClient () {
      this.$confirm('Tem certeza que deseja excluir?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        center: true,
        type: 'warning'
      }).then( async () => {
        this.loadingPage = true
        this.error = {}
        try {
          await deleteApiClient('/'+this.apiDetails.id)
          this.$message({
            showClose: true,
            message: 'Client API deletado com sucesso',
            type: 'success'
          });
          this.ruleForm = {};
          this.apiDetails = {};
          await this.listDados();
        } catch (e) {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false;
          this.dialogVisible = false;
        }
      }).catch(() => {});
    },
    async handleCreateToken() {
      this.loadingPage = true
      try {
        let response = await postApiClient({
          ...this.ruleForm,
          email: this.currentUser.email,
          type: 'production',
          user_id: this.currentUser.id
        })

        this.tokenJwt = response.data.token_jwt
        this.dialogVisible = true
        this.$message({
          showClose: true,
          message: 'Adicionado com sucesso',
          type: 'success'
        })
        this.dialogVisibleGene = false
        await this.close();
        await this.listDados();
      } catch (e) {
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    async generateToken() {
      this.loadingPage = true
      try {
        let response;
        this.ruleForm.token_jwt = ''
        response = await postGenerateTokenApiClient({
          id: this.apiDetails.id,
          data: {...this.ruleForm, type: "production"}
        })
        this.ruleForm.token_jwt = response.data.token_jwt
        this.$message({
          showClose: true,
          message: 'Token Gerado',
          type: 'success'
        })
        this.dialogVisibleGene = false
        await this.listDados();
      } catch (e) {
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    openGenrateToken() {
      this.ruleForm.email = this.currentUser.email;
      this.dialogVisibleGene = true
    },
    close() {
      this.$refs['ruleForm'].resetFields()
      this.$refs['ruleForm'].clearValidate()
      this.ruleForm = {}
      this.apiDetails = {};
    },
    init() {
      this.listDados()
    },
    async listDados () {
      this.loadingPage = true
      this.error = {}
      try {
        let response = await getApiClient(`?user_id=${this.currentUser.id}`)
        if (response.data.data.length > 0) {
          this.apiDetails = {
            ...response.data.data[0],
            name: response.data.data[0].user.name,
            email: response.data.data[0].user.email
          };
          this.tokenJwt = this.apiDetails.token_jwt;
        }
      } catch (e) {
        this.$message({
          showClose: true,
          message: 'Erro ao carregar lista',
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
  },
  mounted() {
    this.init()
    }
}
</script>

<style scoped>
  .card-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
